import type { SPAPillTone } from '../../shared/SPAPill';

// Same colour per role as the legacy ui/Pill mapping (admin purple, coordinator yellow, student
// green, teacher blue), so a role reads the same on either mount.
const ROLE_TONES: Record<string, SPAPillTone> = {
  admin: 'accent',
  coordinator: 'warning',
  student: 'success',
  teacher: 'info',
};

const rolePillTone = (role: string): SPAPillTone => ROLE_TONES[role] ?? 'neutral';

export default rolePillTone;
